import axios from "axios";

export function getProducts(page= 1, limit) {
    return axios.get(`products?page=${page}&limit=${limit}`);
}

export function getProduct(id) {
    return axios.get('product/' + id);
}